import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { PropsTable, TOGGLE_INPUT_PROPS, TOGGLE_NEW_PROPS, TOGGLE_PROPS } from "./Props/Props";

const CATEGORIES = {
  core:     { label: "Core",     color: "#EFF6FF", textColor: "#1D4ED8" },
  display:  { label: "Display",  color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
};


function ToggleList() {
  const [toggleNew, setToggleNew] = useState(true);

  const [toggle, setToggle] = useState(true);
  const [toggleDisabled, setToggleDisabled] = useState(true);
  const [toggleWithLabel, setToggleWithLabel] = useState(false);

  const [toggleInput, setToggleInput] = useState(true);
  const [toggleInputDisabled, setToggleInputDisabled] = useState(false);

  const handleToggleChange = (newValue) => {
    console.log("Toggle Value: ", newValue);
    setToggle(newValue);
  };

  return (
    <div>
      <div className="flex flex-col gap-10 my-5 mb-30">
        <FormFieldSet
          value={toggleNew}
          type="toggleNew"
          onChange={setToggleNew}
          title="Toggle New"
        />

        <div className="flex gap-8">
          <FormFieldSet
            isChecked={toggle}
            type="toggle"
            onChange={setToggle}
            title="Toggle"
          />
          <FormFieldSet
            isChecked={toggleDisabled}
            type="toggle"
            onChange={setToggleDisabled}
            title="Toggle Disabled"
            disabled
          />
          <FormFieldSet
            isChecked={toggleWithLabel}
            type="toggle"
            onChange={setToggleWithLabel}
            title="Toggle with label"
            label={"On/Off"}
          />
        </div>

        <div className="grid grid-cols-4 gap-8 my-5">
          <FormFieldSet
            value={toggleInput}
            type="toggleInput"
            onChange={setToggleInput}
            title="Toggle Input"
            leftText={"Boy"}
            rightText={"Girl"}
            leftIcon={"boy"}
            rightIcon={"girl"}
          />

          <FormFieldSet
            value={toggleInputDisabled}
            type="toggleInput"
            onChange={setToggleInputDisabled}
            title="Toggle Input Disabled"
            leftText={"Boy"}
            rightText={"Girl"}
            leftIcon={"boy"}
            rightIcon={"girl"}
            disabled
          />
        </div>
      </div>

      <PropsTable
        data={TOGGLE_NEW_PROPS}
        title="Toggle New — Props Reference"
        typeLabel='type="toggleNew"'
        categories={CATEGORIES}
        />
      <PropsTable
        data={TOGGLE_PROPS}
        title="Toggle — Props Reference"
        typeLabel='type="toggle"'
        categories={CATEGORIES}
        />
      <PropsTable
        data={TOGGLE_INPUT_PROPS}
        title="Toggle Input — Props Reference"
        typeLabel='type="toggleInput"'
        categories={CATEGORIES}
      />
    </div>
  );
}

export default ToggleList;